export const images: {
  [ key : string ]
  : string[]
} = {
    sails: [
        "3812B796-2DE1-419C-B59F-D28FA5AE19EE.jpeg",
        "F56A0905-CBEC-4C3D-A5D1-B5C6ED9333F7.jpeg","IMG_5793.jpeg","IMG_5798.jpeg","IMG_5799.jpeg","IMG_5805.jpeg","IMG_5806.jpeg","IMG_5807.jpeg","IMG_5810.jpeg",

        "20250614_115432.jpg",
        "20250614_115541.jpg",
        "20250614_115707.jpg",
        "20250614_115745.jpg",
        "20250614_115826.jpg",
        "20250614_115914.jpg",
        "20250614_115943.jpg",
        "20250614_120025.jpg",
        "20250614_120123.jpg",
        "20250614_120157.jpg",
        "20250614_120552.jpg",
        "20250614_120706.jpg",
        "20250614_120753.jpg",
        "20250614_120818.jpg",
        "20250614_121149.jpg",
        "20250614_121207.jpg",
        "20250614_121240.jpg",
        "20250614_121925.jpg",
        "20250614_122144.jpg",
        "20250614_123457.jpg",
        "20250614_123744.jpg",
        "20250614_124050.jpg",
        "IMG-20250616-WA0002.jpg",
        "IMG-20250616-WA0003.jpg",
        "IMG-20250616-WA0004.jpg",
        "IMG-20250616-WA0005.jpg",
        "IMG-20250616-WA0006.jpg",
        "IMG-20250616-WA0007.jpg",
        "IMG-20250616-WA0008.jpg"
],
  largeTrailers: [
        "123213.jpg",
        "123224.jpg",
        "123234.jpg",
        "123253.jpg",
        "123306.jpg",
        "123313.jpg",
        "123317.jpg",
        "123321.jpg",
        "123352.jpg",
        "123410.jpg",
  ],
    dinghyPark: [
        "20250418_114015.jpg",
        "20250418_114023.jpg",
        "20250618_182011.jpg",

    "123623.jpg",
    "123842.jpg",
    "123914.jpg",
    "123937.jpg",
] };
